var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6 5.79999C11.6 8.78234 9.18239 11.2 6.20005 11.2C3.2177 11.2 0.800049 8.78234 0.800049 5.79999C0.800049 2.81765 3.2177 0.399994 6.20005 0.399994C9.18239 0.399994 11.6 2.81765 11.6 5.79999ZM5.57543 8.65925L9.58188 4.6528C9.71793 4.51675 9.71793 4.29616 9.58188 4.16011L9.0892 3.66743C8.95315 3.53136 8.73256 3.53136 8.59649 3.66743L5.32908 6.93482L3.8036 5.40934C3.66756 5.2733 3.44696 5.2733 3.3109 5.40934L2.81821 5.90203C2.68217 6.03807 2.68217 6.25867 2.81821 6.39471L5.08273 8.65923C5.21879 8.79529 5.43937 8.7953 5.57543 8.65925Z",
    fill: "#31B23A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSuccess);
export default __webpack_public_path__ + "97120/static/media/CheckSuccess.20ac26d869ddcbfa055b59c77d429bf7.svg";
export { ForwardRef as ReactComponent };